import React from 'react';
import { onboardingStyles } from '../../../components/UI/OnboardingModal.styles';

export const MAP_LIST_ONBOARDING_KEY = 'mapListOnboarding';

export const mapListOnboarding = {
  title: 'Will this house fit your backyard?',
  badge: 'House Building Guide',
  image: 'https://s3.us-west-2.amazonaws.com/adu.homewip/tutorial/onboarding-map-1.webp',
  content: (
    <>
      <p className={onboardingStyles.paragraph}>
        <span className={onboardingStyles.highlight}>Enter your address.</span>
      </p>

      <p className={onboardingStyles.paragraph}>
        Use filters to select a plan by square footage and the number of bedrooms and bathrooms.
      </p>

      <p className={onboardingStyles.paragraph}>
        Scroll to see different floor plans - use width and length for reference.
      </p>

      <p className={onboardingStyles.paragraph}>
        <span className={onboardingStyles.highlight}>Select the floor plan</span> to try in your
        backyard.
      </p>

      <p className={onboardingStyles.paragraph}>
        Drag and turn the house plan to the desired location.
      </p>
    </>
  ),
  buttonText: 'Get started',
};

export const planViewOnboarding = {
  title: 'Your Future House',
  badge: 'See the house in more detail',
  image: 'https://s3.us-west-2.amazonaws.com/adu.homewip/tutorial/onboarding-plan-view-1.webp',
  content: (
    <>
      <p className={onboardingStyles.paragraph}>
        The <span className={onboardingStyles.highlight}>estimate</span> is a starting point. It
        does not take into account site-specific conditions or contractors’ business model. More
        details are needed to get a custom quote. You will be able to request a quote after the next
        phase of your project.
      </p>

      <p className={onboardingStyles.paragraph}>
        Scroll down to see the <span className={onboardingStyles.highlight}>floor plan in 2D</span>.
      </p>

      <p className={onboardingStyles.paragraph}>
        The <span className={onboardingStyles.highlight}>gallery</span> shows floor plans and
        possible exterior options.
      </p>

      <p className={onboardingStyles.paragraph}>
        When in doubt, <span className={onboardingStyles.highlight}>book a call</span> with an ADU
        expert.
      </p>
    </>
  ),
  buttonText: 'Get started',
};
